"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[804],{

/***/ 34450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBackArrowMobile(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19 12H5M12 19l-7-7 7-7",
    stroke: "#454F59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgBackArrowMobile);

/***/ }),

/***/ 70804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cashlesscard; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var dist = __webpack_require__(79749);
;// CONCATENATED MODULE: ./components/partnership/cashlesscard/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0 1.15rem 0 1.15rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 450px;\n    @media screen and (min-width: 780px) {\n        width: 360px;\n        top: 30px;\n        border: 1px solid #f6f7fb;\n        margin: auto;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    overflow: scroll;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Wrapper = dist.styled.div(_templateObject());
var PageWrapper = dist.styled.div(_templateObject1());
var ContentWrapper = dist.styled.div(_templateObject2());

// EXTERNAL MODULE: ./public/images/backArrowMobile.svg
var backArrowMobile = __webpack_require__(34450);
// EXTERNAL MODULE: ./utils/serverConfig/index.ts
var serverConfig = __webpack_require__(24733);
;// CONCATENATED MODULE: ./components/partnership/cashlesscard/header/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: -ms-grid;\n    display: grid;\n    grid-template-columns: auto auto;\n    margin: 25px 0 0 25px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styles_Wrapper = dist.styled.div(styles_templateObject());

;// CONCATENATED MODULE: ./components/partnership/cashlesscard/header/index.tsx




function header(param) {
    var policyid = param.policyid;
    var onBack = function() {
        window.location.href = "".concat((0,serverConfig/* getDomainOrigin */.IY)(), "/partnership/policy?policyid=").concat(policyid);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(backArrowMobile/* default */.Z, {
            onClick: onBack
        })
    });
}
/* harmony default export */ var cashlesscard_header = (header);

// EXTERNAL MODULE: ./public/images/fhpl.png
var fhpl = __webpack_require__(22494);
;// CONCATENATED MODULE: ./components/partnership/cashlesscard/cardDetails/styles.ts

function cardDetails_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n    padding: 20px;\n    background: #f6f7fb;\n    border-radius: 6px;\n"
    ]);
    cardDetails_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 1fr;\n    grid-template-columns: 1fr 1fr;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: flex-start;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: flex-end;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 19px;\n    letter-spacing: 0.5px;\n    text-align: left;\n    margin-top: 20px;\n    color: #343758;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 1fr;\n    grid-template-columns: 1fr 1fr;\n    justify-items: flex-start;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin-top: 16px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 500;\n    font-size: 9px;\n    line-height: 11px;\n    letter-spacing: 0.05em;\n    color: #343758;\n    text-align: left;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 10px;\n    line-height: 12px;\n    letter-spacing: 0.07em;\n    color: #343758;\n    text-align: left;\n    margin-top: 6px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var SingleCashlessCardWrapper = dist.styled.div(cardDetails_styles_templateObject());
var LogoWrapper = dist.styled.div(styles_templateObject1());
var AckoLogo = dist.styled.div(styles_templateObject2());
var LinkedAssetWrapper = dist.styled.div(_templateObject3());
var PolicyOwnerText = dist.styled.div(_templateObject4());
var PolicyDetailsWrapper = dist.styled.div(_templateObject5());
var PolicyNumberWrapper = dist.styled.div(_templateObject6());
var PolicyNumberTitle = dist.styled.div(_templateObject7());
var PolicyNumberText = dist.styled.div(_templateObject8());

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/constants/index.ts
var constants = __webpack_require__(61485);
;// CONCATENATED MODULE: ./components/partnership/cashlesscard/cardDetails/index.tsx





function cardDetails(param) {
    var name = param.name, uhid = param.uhid, policyNumber = param.policyNumber, relationship = param.relationship;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(SingleCashlessCardWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LogoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(AckoLogo, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: constants/* AckoLogoConfig.gradient */.G4.gradient,
                            alt: "",
                            width: 50,
                            height: 16
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LinkedAssetWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("img", {
                            src: fhpl/* default */.Z,
                            alt: "",
                            style: {
                                width: "34px",
                                height: "16px"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PolicyOwnerText, {
                style: {
                    marginTop: "10px"
                },
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PolicyNumberWrapper, {
                style: {
                    marginTop: "10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PolicyNumberText, {
                    children: [
                        "UHID: ",
                        uhid
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PolicyDetailsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PolicyNumberWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PolicyNumberTitle, {
                                children: "Policy number"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PolicyNumberText, {
                                children: policyNumber
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PolicyNumberWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PolicyNumberTitle, {
                                children: "Relationship"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PolicyNumberText, {
                                children: relationship
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var cashlesscard_cardDetails = (cardDetails);

;// CONCATENATED MODULE: ./components/partnership/cashlesscard/instruction/styles.ts

function instruction_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 24px 0 120px 0;\n    min-height: 300px;\n\n    @media screen and (min-width: 780px) {\n        min-height: 260px;\n    }\n"
    ]);
    instruction_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function instruction_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: normal;\n    font-size: 10px;\n    line-height: 12px;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n    color: #737f8b;\n    margin-bottom: 12px;\n"
    ]);
    instruction_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function instruction_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 8px;\n"
    ]);
    instruction_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin: 5px 10px 0 0;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0.02em;\n    color: #434f5a;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var InstructionWrapper = dist.styled.div(instruction_styles_templateObject());
var InstructionTitle = dist.styled.div(instruction_styles_templateObject1());
var InstructionRowWrapper = dist.styled.div(instruction_styles_templateObject2());
var Dot = dist.styled.div(styles_templateObject3());
var Instruction = dist.styled.div(styles_templateObject4());

;// CONCATENATED MODULE: ./public/images/purple-circle.svg
var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPurpleCircle(props) {
  return /*#__PURE__*/compat_module.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/compat_module.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#9364ED"
  })));
}
/* harmony default export */ var purple_circle = (SvgPurpleCircle);
;// CONCATENATED MODULE: ./components/partnership/cashlesscard/instruction/index.tsx




function index() {
    var InstructionRow = function(param) {
        var text = param.text;
        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(InstructionRowWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Dot, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(purple_circle, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Instruction, {
                    children: text
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(InstructionWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstructionTitle, {
                children: "Instructions:"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstructionRow, {
                text: "Pre-authorisation compulsary for FHPL, prior to planned admission and within 24hours for emergencies."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstructionRow, {
                text: "Out Patient treatment not covered."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstructionRow, {
                text: "Admission for Investigation/Evalution not covered."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstructionRow, {
                text: "Leave back all claims related documents with Network Hospital."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstructionRow, {
                text: "Terms & Conditions of Insurance Company applicable"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstructionRow, {
                text: "Refer Guide book for further details"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(InstructionRow, {
                text: "Cashless hospitalization in network hospital can be obtained in conjuction with this card, an authorization letter issued by FHPL and photo identification such as Voter ID, Drivers License etc."
            })
        ]
    });
}
/* harmony default export */ var instruction = (index);

;// CONCATENATED MODULE: ./components/partnership/cashlesscard/footer/styles.ts

function footer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 65px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    background: #f6f7fb;\n    bottom: 0;\n    position: fixed;\n    margin-right: 0;\n    @media screen and (min-width: 780px) {\n        width: 360px;\n        position: relative;\n    }\n"
    ]);
    footer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function footer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: normal;\n    font-size: 10px;\n    line-height: 12px;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n    color: #737f8b;\n"
    ]);
    footer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function footer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 10px;\n    line-height: 12px;\n    text-align: right;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n    color: #343758;\n"
    ]);
    footer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var FooterWrapper = dist.styled.div(footer_styles_templateObject());
var TollFreeNumber = dist.styled.div(footer_styles_templateObject1());
var styles_Number = dist.styled.div(footer_styles_templateObject2());

;// CONCATENATED MODULE: ./components/partnership/cashlesscard/footer/index.tsx



function footer() {
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(FooterWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TollFreeNumber, {
                children: "Toll Free Number:"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Number, {
                children: "1800-266-2256"
            })
        ]
    });
}
/* harmony default export */ var cashlesscard_footer = (footer);

// EXTERNAL MODULE: ./utils/segment/constants.ts
var segment_constants = __webpack_require__(77316);
// EXTERNAL MODULE: ./utils/segment/types.ts
var types = __webpack_require__(68242);
// EXTERNAL MODULE: ./components/partnership/context/types.ts
var context_types = __webpack_require__(71487);
;// CONCATENATED MODULE: ./components/partnership/cashlesscard/index.tsx







// events


// context

function cardInstructions(param) {
    var name = param.name, uhid = param.uhid, policyNumber = param.policyNumber, relationship = param.relationship, policyid = param.policyid;
    var sendSegmentEventForInternet = (0,compat_module.useContext)(context_types/* PartnershipContext */.S).sendSegmentEventForInternet;
    (0,compat_module.useEffect)(function() {
        sendSegmentEventForInternet(segment_constants/* SegmentEventNameTypes.VIEW */.Pg.VIEW, {
            page_type: types/* InternetFnolPageTypes.PDP_HEALTH_CARD */.p3.PDP_HEALTH_CARD,
            page_name: types/* InternetFnolPages.POLICY_DISPLAY_PAGE */.m9.POLICY_DISPLAY_PAGE,
            view_name: types/* InternetFnolViewEvents.VIEW_PDP_HEALTH_CARD */.bC.VIEW_PDP_HEALTH_CARD
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PageWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ContentWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(cashlesscard_header, {
                    policyid: policyid
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Wrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(cashlesscard_cardDetails, {
                            name: name,
                            uhid: uhid,
                            policyNumber: policyNumber,
                            relationship: relationship
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(instruction, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(cashlesscard_footer, {})
            ]
        })
    });
}
/* harmony default export */ var cashlesscard = (cardInstructions);


/***/ }),

/***/ 22494:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAgCAMAAACcqC7MAAABfVBMVEVHcEx7JGlvH2d5I2l+Kmp8JGp8JGmBIG5/H2p8JWp8JGp5JGZ8JGp7I2l3GGR8JGp7I2l7JWp8JGl8JGl6Iml9J2x7I2h7I2l8JGl7ImvFi7Z8JGp8JGp8I2nFe697JGp7I2l8IWd7I2l8JGqAJmx8JGqrYJiiWol+Jm316PF7I2iJNHXHeq97I2msZpu3cqR8JWp7JGmkU47x1OX34PLt1OXKfrF7JGmybZ97JGmxaJ6CK298JGqlVI7w2+jUlb97JGmTQH+TRYK1dKTfwdapV5K/cafHe67drs58JWrbpMjjutXz4Ozz4+6KNXiOP3vkx9vGkbiKNHebSIaiUYzUj763aKCvXpfpyd7fsdGYRITPh7j26/N6JGnFea6TPn7DdauuXJfDdavhttP37vTz4u7PibiQP3yPPXzHl7u6eam2dKXCm7u+k7XIpcG4ia7PscieXpHCmrm1ZZ727PPUlb/07vTXmcHTkLz26/L27vT07/SLP3t8JWrdrs5O3AAJAAAAfXRSTlMA/gggBfB3AhH43Q72oQqEmfnJwTsVYVLWNAX74loOJXJFuekY0DEJLPtK3uJ+J3XzaOAVC/72sk+NHbKqE0v8aqNIsfCA9T0n5fj9yfM2Iv1PPdtyZOjjooPK62t3XHXGs7Xa64f6j+shmYrv4tXG9frC6pTrLrGh3rIw/InwCQcAAAMQSURBVEjHzZX5T+JAFMdrO2WGtlTEcgi2RcoNAoJyGFAEvDVe8b51XY237n10//adUtBiDJL1l/0mbdqX18/M+86bKUF0rlAlRLxbK48r7vcygrfLt0HYYbI0vb69tfV5byzT8kUimby5vEp0QoCjkxtT8d25+ZHIYu3bitSMo8rj/cPvh/ubc4F8iwFW19KTCUmSZrYXIpHl8fiBhoHB84uL69rdxF3tOkZbqDcY4dhECdRn5B4eW4iMzO0eBd3B4/TO4VK+mgiNVvMlZ8DnbwtB1gBqGAEJd+bsw8ifj/GTjeMgC2BoyU1AewgCgSm3tZcKDBr9GR77EZkfz16WoI7FF76hXito5yrlKhOtlEVsTPZKMgZlV6HtTOw5n9F7af20phmTPRl96jKILIrQFgIGZk18M7uUP4p/n8ns1Y1JNjDAX5z1tl9kyDr6bSJlR/6lykR6szotQWL4689FbEy8mk8kEpWJWExk32oUvq/IMIyLicV2JoOSPnrm19npl+zU1KfNdHrtUCY7aFkkC06HczXsDz1XPpyZmT5IJpP54GjHGxkC+MI6iLsvFHJD4n/Xvskgr4MX8d2vT5vymrxRQIrGhKgdVyZ7TaYBY9eauWeZlW7k4zilT2/zAYWjrSTqNWRwik8A0ElznJU3QLpU1dPMoG0U26uqdBNCq2YLiWwqTtHH6ulSewJh4ORU9SXEVXY0JIDXIT2F8pAmr82scoP8KxCPhYegLvxtA6IFyOgTJCXrLkFBUT0+9CqEDQ92Y3mpJgQ5tPci14TQlA4BbSCUz4Pr5nKoCXHSqq4nCJCdoigOtSlnwNWPFYg2yxEsjBagPc8QlEt5PNpQmrHRlKoW2ZczqcuvrbwOqb/LYuoJIjtnOTMWR/fiJQ4rqsrIoBVi2Jevrw4ti3XXugejWiOyPrymPoGy18V2CqFath6MKriyVL9LU2D/3yAEFJmUp+G9IhAEPoIKBgiPz6RAWIcIAcZVAGwOH1L+l0eD32RjdBXs+AeAENlyQOJAwzISP/LQGGnh8KguEhJ/AVbPoKcnoWw5AAAAAElFTkSuQmCC");

/***/ })

}]);